export const ARTICLES_ACTION_TYPES = {
  FETCH_ARTICLES_START: 'ARTICLES/FETCH_ARTICLES_START',
  FETCH_ARTICLES_SUCCESS: 'ARTICLES/FETCH_ARTICLES_SUCCESS',
  FETCH_ARTICLES_FAILED: 'ARTICLES/FETCH_ARTICLES_FAILED',
  POST_ARTICLE_START: 'ARTICLES/POST_ARTICLE_START',
  POST_ARTICLE_FAILED: 'ARTICLES/POST_ARTICLE_FAILED',
  POST_ARTICLE_SUCCESS: 'ARTICLES/POST_ARTICLE_SUCCESS',
  DELETE_ARTICLE_START: 'ARTICLES/DELETE_ARTICLE_START',
  DELETE_ARTICLE_FAILED: 'ARTICLES/DELETE_ARTICLE_FAILED',
  DELETE_ARTICLE_SUCCESS: 'ARTICLES/DELETE_ARTICLE_SUCCESS',
};